import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import HomePage from "./pages/index";
import "./assets/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import "./assets/css/icofont.css";
import "swiper/components/navigation/navigation.scss";
import "swiper/swiper.scss";
import "./assets/css/animate.css";
import "lightgallery.js/dist/css/lightgallery.css";
import "swiper/components/pagination/pagination.scss";
import AboutPage from "./pages/about";
import ServicePage from "./pages/service";
import ServiceDetails from "./templates/service-details";
import ContactPage from "./pages/contact";
import ColumnPage from "./pages/column";
import NavScrollTop from "./components/nav-scroll-top";

const App = () => {
    useEffect(() => {
        AOS.init({
            offset: 80,
            duration: 900,
            once: true,
            easing: "ease-out-cubic",
        });
        AOS.refresh();
    }, []);
    return (
        <Router>
            <NavScrollTop>
                <Switch>
                    <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={HomePage} />
                    <Route path={`${process.env.PUBLIC_URL + "/about"}`} component={AboutPage} />
                    <Route path={`${process.env.PUBLIC_URL + "/service"}`} component={ServicePage} />
                    <Route path={`${process.env.PUBLIC_URL + "/service-details/:id"}`} component={ServiceDetails} />
                    <Route path={`${process.env.PUBLIC_URL + "/column"}`} component={ColumnPage} />
                    <Route path={`${process.env.PUBLIC_URL + "/contact"}`} component={ContactPage} />
                </Switch>
            </NavScrollTop>
        </Router>
    );
};

export default App;
